import { useState } from "react";

import { InformationIcon, SectionHeader } from "~/common/components";
import { PATIENT_PREVIEW_KEYS, patientPreviewData } from "~/providers/utils";
import { ScoresData } from "~/providers/utils/types/patientPreviewTypes";
import { PatientPreviewInfoModal } from "../common";
import { PatientPreviewSelfReportedScores } from "../common/selfReportedScores";

interface PatientPreviewSelfReportedScoresV1Props {
  scores: ScoresData;
}

export const PatientPreviewSelfReportedScoresV1 = ({
  scores,
}: PatientPreviewSelfReportedScoresV1Props) => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  const { description, bottomDescription, options } =
    patientPreviewData[PATIENT_PREVIEW_KEYS.self_reported];

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <SectionHeader>Self-reported scores</SectionHeader>
          <button onClick={() => setShowInfoModal(true)}>
            <InformationIcon className="size-4 text-gray-20" />
          </button>
        </div>
        <PatientPreviewSelfReportedScores scores={scores} />
      </div>
      <PatientPreviewInfoModal
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        title="Self-reported scores"
        description={description}
        options={options}
        bottomDescription={bottomDescription}
      />
    </>
  );
};
